import { render, staticRenderFns } from "./Kchart.vue?vue&type=template&id=11ec0b20&"
import script from "./Kchart.vue?vue&type=script&lang=js&"
export * from "./Kchart.vue?vue&type=script&lang=js&"
import style0 from "./Kchart.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports